// ** Core JWT Import
import jwtHandler from '@src/@core/auth/jwt/useJwt';

const { jwt } = jwtHandler({});

export default jwt;
